import { Image, ImageProps } from 'expo-image';
import { StyleSheet } from 'react-native';

import { imageUrlBuilder } from '@fhs/cms-groq-queries';
import { useLoyaltyHomepageConfigAppQuery } from '@fhs/loyalty-homepage';

export type TopMarketingImageProps = Omit<ImageProps, 'children' | 'source'>;

export function TopMarketingImage(props: TopMarketingImageProps) {
  const { data: loyaltyHomepageConfigDocument } = useLoyaltyHomepageConfigAppQuery();
  const appTopImage = loyaltyHomepageConfigDocument?.appTopImage;
  const appTopImageAltText =
    loyaltyHomepageConfigDocument?.appTopImageAltText;
  const imageAccessibilityLabel =
    appTopImageAltText?.trim() || 'Restaurant promotional image';

    if (!appTopImage) {
      return null;
    }

  return (
    <Image
      source={(() => {
        const width = 800;
        const height = 811;
        return {
          uri: imageUrlBuilder.image(appTopImage).width(width).height(height).format('webp').url(),
          height,
          width,
          blurhash: appTopImage.asset.metadata.blurHash
        };
      })()}
      accessibilityLabel={imageAccessibilityLabel}
      alt={imageAccessibilityLabel}
      contentFit="contain"
      style={[styles.marketingImage, props.style]}
    />
  );
}

const styles = StyleSheet.create({
  marketingImage: {
    aspectRatio: 800 / 811,
    minHeight: 200,
    alignSelf: 'center',
    flexGrow: 1,
    maxWidth: '96%',
  },
});
